import React, { useEffect } from 'react';
import { Slide } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import PageLoader from '../PageComponents/PageLoader';
import { fetchError, fetchSuccess } from '../../../redux/actions';
import { makeStyles } from '@material-ui/styles';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

//不知道为什么，窗口会被顶部的工具栏遮住，所以调整下位置
const useStyles = makeStyles(theme => ({
  snackbarRoot: {
    '&.MuiSnackbar-anchorOriginTopRight': {
      top: 74,
      left: 'auto',
      right:10
    }
  },
}));

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const ContentLoaderImple = () => {
  const { error, loading,stableLoading,message,loadingMessage,messageTicks } = useSelector(({ common }) => common);
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();

  // useEffect(() => {
  //   setTimeout(() => {
  //     dispatch(fetchError(''));
  //   }, 3000);
  // }, [dispatch, error, message]);

  const clearMessage =()=>{
    dispatch(fetchError(''));
  }

  useEffect(() => {
    if(error)
      enqueueSnackbar(error, { variant:"error" });
    
    if(message)
      enqueueSnackbar(message, { variant:"success" });
}, [messageTicks]);

  return (
    <React.Fragment>
      {(loading || stableLoading) && <PageLoader message={loadingMessage} />}
    </React.Fragment>
  );
};



const Snackbar = ({children})=>{

  const notistackRef = React.createRef();
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }

    return (
      <SnackbarProvider maxSnack={5} 
        ref={notistackRef}
        autoHideDuration={3000} 
        anchorOrigin={{vertical: 'top',horizontal: 'right'}}
        action={(key) => (
          <IconButton key="close" aria-label="Close" color="inherit" onClick={onClickDismiss(key)}>
              <CloseIcon style={{fontSize:"15px"}}/>
          </IconButton>
        )}
      >
        {children}
    </SnackbarProvider>);
}

const ContentLoader=()=>{
  return (
    <Snackbar>
      <ContentLoaderImple />
    </Snackbar>
  );
}

export default ContentLoader;
